import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { toast } from 'sonner'

import { UploadIconButton } from '@/components/UploadIconButton'
import {
  fillApplicationErrorMessage,
  invalidateFillApplication,
  uploadIntake,
} from '@/models/fillApplication'
import { FillApplicationEvent, trackFillApplication } from './fillApplicationAnalytics'
import { intakeFilesProblem } from './intakeLimits'

/** Reads a loss run the way the Documents tab does, so its claims land in the loss runs below. */
export function LossRunUploadButton({ orgId }: { orgId: string }) {
  const queryClient = useQueryClient()
  const [uploading, setUploading] = useState(false)

  async function upload(file: File) {
    const problem = intakeFilesProblem([file])
    if (problem) {
      toast.error(problem)
      return
    }
    setUploading(true)
    try {
      await uploadIntake(orgId, [file])
      trackFillApplication(FillApplicationEvent.FILES_DROPPED, { count: 1, from: 'loss_runs' })
      toast.success(`Reading ${file.name}. Its claims show here once it's read.`)
      await invalidateFillApplication(queryClient, orgId)
    } catch (error) {
      toast.error(fillApplicationErrorMessage(error))
    } finally {
      setUploading(false)
    }
  }

  return (
    <UploadIconButton label="Upload loss run" isLoading={uploading} onUpload={(file) => void upload(file)} />
  )
}
